<template>
<div style="height:100%">
    <div class="handleBox flex flex-jc-sb flex-ai-c">
        <el-page-header @back="goBack" content="商品" style="color:#95A1B9"></el-page-header>
        <el-button type="primary" size="small" @click="onSubmit" style="width:120px;margin:0 20px 0 auto;" v-if="!show">提交</el-button>
    </div>

    <div class="commonMain">
        <el-form ref="formAuth" :rules="formRules" :model="formData" label-width="120px" label-position="right" size="small" class="alertForm alertForm2">
            <el-form-item label="商品标题" prop="name">
                <el-input v-model="formData.name" autocomplete="off" :disabled="show" placeholder="商品标题"></el-input>
            </el-form-item>
            <el-form-item label="商品副标题">
                <el-input v-model="formData.sub_name" autocomplete="off" :disabled="show" placeholder="商品副标题"></el-input>
            </el-form-item>
            <el-form-item label="运费设置" prop="postage">
                <el-input v-model="formData.postage" autocomplete="off" :disabled="show" placeholder="运费设置"></el-input>
            </el-form-item>
            <el-form-item label="分享描述" prop="desc">
                <el-input v-model="formData.desc" autocomplete="off" :disabled="show" placeholder="分享描述"></el-input>
            </el-form-item>
            <el-form-item label="是否自提" prop="goods_send_zi_is">
                <el-select v-model="formData.goods_send_zi_is" clearable placeholder="是否自提" :disabled="show">
                    <el-option label="可自提" :value="1"></el-option>
                    <el-option label="不可自提" :value="2"></el-option>
                </el-select>
            </el-form-item> 
            <el-form-item label="提货积分" prop="ti_huo_ji_fen">
                <el-input v-model="formData.ti_huo_ji_fen" autocomplete="off" :disabled="show" placeholder="请输入提货积分">
                    <template slot="append">%</template>
                </el-input>
            </el-form-item>
            <el-form-item label="服务费" prop="ji_fen_goods_service_per" v-if="formData.goods_send_zi_is==1">
                <el-input v-model="formData.ji_fen_goods_service_per" autocomplete="off" :disabled="show" placeholder="请输入积分比例">
                    <template slot="append">%</template>
                </el-input>
            </el-form-item>
            <el-form-item v-if="formData.goods_send_zi_is==1"></el-form-item>
				
            <!--
				<el-form-item label="新品推荐">
					<el-select v-model="formData.is_new" clearable placeholder="" :disabled="show">
						<el-option v-for="val in selectState" :key="val.id" :label="val.name" :value="val.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="热销推荐">
					<el-select v-model="formData.is_recommend" clearable placeholder="热销推荐" :disabled="show">
						<el-option v-for="val in selectState" :key="val.id" :label="val.name" :value="val.id"></el-option>
					</el-select>
				</el-form-item>
				-->
            <el-form-item label="商品主图" prop="main_pic">
                <div class="photoBox">
                    <div class="photo flex flex-wrap">
                        <div v-if="formData.main_pic!=''">
                            <el-image :src="getImgUrl(formData.main_pic)" fit="cover" :preview-src-list="[domain + '/' + formData.main_pic]"></el-image>
                            <i class="el-icon-error" @click="deleteMain_pic(index)" v-if="!show"></i>
                        </div>
                        <label v-else>
                            <i class="el-icon-plus"></i>
                            <input type="file" class="uploadMainPic" :value="filevalue" style="display:none" @change="upload('uploadMainPic')" />
                        </label>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="商品展示图" prop="banner_list">
                <div class="photoBox">
                    <div class="photo flex flex-wrap">
                        <div class="" v-for="(item,index) in formData.banner_list" :key="index">
                            <el-image :src="getImgUrl(item)" fit="cover" :preview-src-list="[domain + '/' + item]">
                            </el-image>
                            <i class="el-icon-error" @click="deleteBanner_list(index)" v-if="!show"></i>
                        </div>
                        <label v-show="(formData.banner_list.length<6) && (!show)">
                            <i class="el-icon-plus"></i>
                            <input type="file" class="uploadBannerList" multiple :value="filevalue" style="display:none" @change="upload('uploadBannerList')" />
                        </label>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="注：">
                <div>商品主图显示在商品列表页面，图片比例1：1，大小在1mb内 </div>
            </el-form-item>
            <el-form-item label="注：">
                <div>商品展示图显示在商品详情页面轮播，图片比例1：1，大小在1mb内 </div>
            </el-form-item>

            <section style="width:100%;margin-bottom:20px">
                <el-form-item label="商品规格">
                    <el-button @click="addNature" type="success" size="mini" :disabled="show">增加属性</el-button>
                    <el-button @click="addSku" type="success" size="mini" :disabled="show">增加属性值</el-button>
                </el-form-item>

                <el-table :data="formData.scpecs.scpecsList" style="width:auto; margin-left:90px;margin-bottom:10px;margin-right: 1%;" size="mini">
                    <!-- 自定义部分 -->
                    <el-table-column v-for="col in formData.scpecs.attribute" :prop="col.name" :key="col.prop" align="center">
                        <template slot="header" slot-scope="scope">
                            <i class="del el-icon-delete-solid" style="color:#F56C6C" @click="delColumn(scope.$index)" v-if="!show"></i>
                            <el-input v-model="col.name" size="mini" class="f-cent" :disabled="show" />
                        </template>
                        <template slot-scope="scope">
                            <el-input size="mini" v-model="scope.row[col.prop]" :disabled="show"></el-input>
                        </template>
                    </el-table-column>

                    <!-- 固定写死的部分 -->
                    <el-table-column prop="sale_price" label="银豆值" align="center">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.sale_price" size="mini" oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)" :disabled="show"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="hong_rate" label="助企积分倍数" align="center">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.hong_rate" size="mini" oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)" :disabled="show"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="number" label="库存" align="center">
                        <template slot-scope="scope">
                            <el-input v-model.number="scope.row.number" size="mini" oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)" :disabled="show"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="fabricate_sales_number" label="拟定销量" align="center">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.fabricate_sales_number" size="mini" oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)" :disabled="show"></el-input>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="level_0_bonus" label="自己的店%" align="center">
							<template slot-scope="scope">
								<el-input v-model="scope.row.level_0_bonus" size="mini" oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)" :disabled="show"></el-input>
							</template>
						</el-table-column> -->
                    <!--<el-table-column prop="level_1_bonus" label="直接奖励%" align="center">-->
                    <!--<template slot-scope="scope">-->
                    <!--<el-input v-model="scope.row.level_1_bonus" size="mini" oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)" :disabled="show"></el-input>-->
                    <!--</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column prop="level_2_bonus" label="间接奖励%" align="center">-->
                    <!--<template slot-scope="scope">-->
                    <!--<el-input v-model="scope.row.level_2_bonus" size="mini" oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)" :disabled="show"></el-input>-->
                    <!--</template>-->
                    <!--</el-table-column>-->
                    <el-table-column prop="spike_price" label="秒杀价格" align="center">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.spike_price" size="mini" oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)" :disabled="show"></el-input>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="ti_huo_fee" label="提货金金额" align="center">
							<template slot-scope="scope">
								<el-input v-model="scope.row.ti_huo_fee" size="mini" oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)" :disabled="show"></el-input>
							</template>
						</el-table-column> -->
                    <el-table-column fixed="right" label="操作" width="80" align="center">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="deleteRow(scope.$index, formData.scpecs.scpecsList)" type="text" size="small" :disabled="show">
                                移除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <p style="font-size:14px;color:red;text-align:center">注:每个商品分红百分比不一样，需要单独在后台设置</p>
            </section>
            <section style="width:100%;margin-right: 1%;">
                <el-form-item label=" 详细内容" style="width:100%" prop="content">
                    <!-- <div ref="editorElem" style="text-align:left;"></div> -->
                    <editorBar :editorMain="formData.content" @change="editorChange" :mayEdit="show"></editorBar>
                </el-form-item>
            </section>
        </el-form>
    </div>
</div>
</template>

<script>
import axios from 'axios';
import editorBar from '@/components/editorBar';
export default {
    data() {
        return {
            fllist: [], //商品分类列表
            formData: {
                is_new: 2,
                is_recommend: 2,
                main_pic: '', //主图
                banner_list: [], //商品展示图
                scpecs: {
                    attribute: [], //规格
                    scpecsList: [], //表格 规格信息
                },
                content: ''
            }, //商品详情
            formRules: {
                name: [{
                    required: true,
                    message: '请输入商品标题',
                    trigger: 'blur'
                }],
                number: [{
                    required: true,
                    message: '请输入库存',
                    trigger: 'blur'
                }],
                ti_huo_fee: [{
                    required: true,
                    message: '请输入提货金金额',
                    trigger: 'blur'
                }],
                desc: [{
                    required: true,
                    message: '请填写分享描述',
                    trigger: 'blur'
                }],
                sale_price: [{
                    required: true,
                    message: '请输入商品银豆值',
                    trigger: 'blur'
                }, {
                    pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                    message: '请输入数字（保留两位小数）',
                    trigger: 'change'
                }],
                main_pic: [{
                    required: true,
                    message: '请上传商品主图',
                    trigger: 'blur'
                }],
                banner_list: [{
                    required: true,
                    message: '请上传商品展示图',
                    trigger: 'blur'
                }],
                postage: [{
                    required: true,
                    message: '请输入运费',
                    trigger: 'blur'
                }, {
                    pattern: /^(([0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                    message: '请输入数字（保留两位小数）',
                    trigger: 'change'
                }],
                content: [{
                    required: true,
                    message: '请输入详情',
                    trigger: 'blur'
                }],
                goods_send_zi_is: [{
                    required: true,
                    message: '请选择是否自提',
                    trigger: 'blur'
                }],
                ji_fen_goods_service_per: [{
                    required: true,
                    message: '请输入服务费',
                    trigger: 'blur'
                }],
                ti_huo_ji_fen: [{
                    required: true,
                    message: '请输入提货积分',
                    trigger: 'blur'
                }],
            },
            main_pic: [{
                required: true,
                message: '请上传商品主图',
                trigger: 'blur'
            }],
            banner_list: [{
                required: true,
                message: '请上传商品展示图',
                trigger: 'blur'
            }],
            content: [{
                required: true,
                message: '请输入详情',
                trigger: 'blur'
            }],
            selectState: [{
                id: 1,
                name: '是'
            }, {
                id: 2,
                name: '否'
            }],

            filevalue: '', //上传图片value
            dialogImageUrl: '',
            editor: null,

            editType: true, //判定商品属性标签是否可编辑
            labelnull: false,
            dialogVisible: false,
            show: false,
        }
    },
    components: {
        editorBar, //富文本编辑器
    },
    mounted() {
        //判断是查看还是编辑
        this.show = this.$route.query.show ? true : false;
        //编辑 赋值
        if (this.$route.query.row) {
            this.formData = JSON.parse(this.$route.query.row);
        }
        //编辑 赋值
        this.getTypeList();

    },
    methods: {
        getTypeList: function () {
            // 商品分类列表
            this.http.post('/admin/goodsZiType/index', {
                curr: 1,
                row: 999,
            }).then(res => {
                this.fllist = res.list;
            });
        },
        goBack() {
            this.$router.go(-1)
        },
        /**
         * 接收富文本子组件输入值
         */
        editorChange: function (value) {
            this.formData.content = value;
        },

        // 图片转换
        getImgUrl(item) {
            var url = this.domain + '/' + item;
            return url;
        },
        // 附件和图片上传获取接口返回的路径
        upload(uploadelement) {
            var loads = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
                customClass: 'myLoading',
            });
            if ((uploadelement == 'uploadBannerList') && (document.querySelector('.' + uploadelement).files.length + this.formData.banner_list.length > 6)) {
                this.$message.error('商品展示图最多可传6张！');
                loads.close();
            } else {
                for (var i = 0; i < document.querySelector('.' + uploadelement).files.length; i++) {
                    var formData = new FormData();
                    formData.append('pic', document.querySelector('.' + uploadelement).files[i]);
                    axios.post(this.domain + '/admin/goods/upPic', formData).then(re => {
                        loads.close();
                        if (re.data.code == '0000') {
                            this.filevalue = "";
                            uploadelement === 'uploadMainPic' ? this.formData.main_pic = re.data.data.saveName : this.formData.banner_list.push(re.data.data.saveName);
                        } else {
                            this.$message.error(re.data.msg);
                        }
                        this.$refs.formAuth.validateField('main_pic');
                        this.$refs.formAuth.validateField('banner_list')
                    }).catch(function () { // 请求失败处理
                        loads.close();
                    });
                }
            }
        },
        // 删除主图
        deleteMain_pic() {
            this.formData.main_pic = '';
            this.$refs.formAuth.validateField('main_pic');
        },
        //删除展示图
        deleteBanner_list(index) {
            this.formData.banner_list.splice(index, 1);
            this.$refs.formAuth.validateField('banner_list')
        },
        // 增加商品属性
        addNature() {
            let len = this.formData.scpecs.attribute.length;
            //新增以 attr_ 开关，也可以自行定义
            this.formData.scpecs.attribute.push({
                name: '商品属性',
                prop: `attr_${len}`
            })
        },
        // 增加商品SKU
        addSku() {
            let data = this.formData.scpecs.scpecsList[0]
            let keys = []
            for (var key in data) {
                keys.push(key);
            }
            let obj = {
                level_0_bonus: 0
            }
            for (let i = 0; i < keys.length; i++) {
                if (keys[i] === 'editable') {
                    obj[keys[i]] = true
                } else {
                    obj[keys[i]] = ''
                }
            }
            obj.number = 0;
            obj.hong_rate = 0;
            obj.fabricate_sales_number = 0;
            obj.level_0_bonus = 0;
            obj.level_1_bonus = 0;
            obj.level_2_bonus = 0;
            obj.spike_price = 0;
            // obj.ti_huo_fee = 0;
            this.formData.scpecs.scpecsList.push(obj);
        },
        //删除一排   scpecsList ARR
        deleteRow(index, rows) {
            rows.splice(index, 1);
        },

        //删除SKU列
        delColumn(index) {
            let str = this.formData.scpecs.attribute[index].name;
            this.formData.scpecs.scpecsList.forEach((item) => {
                // delete item[str];
                this.$delete(item, str)
            })
            this.formData.scpecs.attribute.splice(index, 1);
        },

        onSubmit() {
            this.$refs['formAuth'].validate((valid) => {
                if (valid) {
                    // start-------- 判断商品属性  以及 属性值 有没有空的
                    let tempArr = [];
                    let tempArrZhi = [];
                    for (var i in this.formData.scpecs.attribute) {
                        tempArrZhi = [];
                        let zhi = false;
                        if (this.formData.scpecs.attribute[i].name == '') {
                            this.labelnull = true;
                        } else {
                            this.labelnull = false;
                        }
                        tempArr.push(this.labelnull)
                        for (var z in this.formData.scpecs.scpecsList) {
                            if (this.formData.scpecs.scpecsList[z][this.formData.scpecs.attribute[i].prop]) {
                                zhi = true
                            } else {
                                zhi = false
                            }
                            tempArrZhi.push(zhi);
                        }
                    }
                    // end-------- 判断商品属性有没有空的
                    console.log(tempArrZhi)
                    if (this.formData.scpecs.attribute.length == 0) {
                        this.$message.error('请至少填写一种规格');
                    } else if (tempArr.includes(true)) {
                        this.$message.error('商品属性不得有为空设置');
                    } else if (this.formData.scpecs.scpecsList.length == 0) {
                        this.$message.error('请至少填写一种规格值');
                    } else if (tempArrZhi.includes(false)) {
                        this.$message.error('商品属性值不得有为空设置');
                    } else {
                        for (var x in this.formData.scpecs.scpecsList) {
                            if (this.formData.scpecs.scpecsList[x].sale_price.toString() == '') {
                                this.$message.error('银豆值不得有为空设置');
                            } else if (this.formData.scpecs.scpecsList[x].number.toString() == '') {
                                this.$message.error('库存不得有为空设置');
                            } else if (this.formData.scpecs.scpecsList[x].fabricate_sales_number.toString() ==
                                '') {
                                this.$message.error('拟定销量不得有为空设置');
                            } else if (this.formData.scpecs.scpecsList[x].level_0_bonus.toString() == '') {
                                this.$message.error('自己的店不得有为空设置');
                            } else if (this.formData.scpecs.scpecsList[x].level_1_bonus.toString() == '') {
                                this.$message.error('直接分店不得有为空设置');
                            } else if (this.formData.scpecs.scpecsList[x].level_2_bonus.toString() == '') {
                                this.$message.error('间接分店不得有为空设置');
                            } else if (this.formData.scpecs.scpecsList[x].spike_price.toString() == '') {
                                this.$message.error('秒杀价格不得有为空设置');
                            } else {
                                if (x == (this.formData.scpecs.scpecsList.length - 1)) {
                                    this.formData['goods_class'] = 3;
                                    this.http.post('/admin/goods/save', this.formData).then(() => {
                                        this.$router.push('ydsplb');
                                    });
                                }
                            }
                        }
                    }
                } else {
                    return false;
                }
            });
        },
    }
}
</script>

<style lang="css">
.el-page-header__content {
    color: #95a1b9;
}

.el-tag {
    margin-right: 10px;
    margin-bottom: 3px;
}

.button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}

.input-new-tag {
    width: 90px;
}

.del {
    cursor: pointer;
    display: none;
    font-size: 18px;
    position: absolute;
    top: 4px;
    right: 12px;
    z-index: 9;
}

.cell:hover .del {
    display: inline;
}
</style>
